const SEARCH_RECENTS_KEY = "ehr_global_search_recent";

export interface StoredRecentSearch {
  id: string;
  label: string;
  subtitle: string;
  href: string;
  patientId?: string;
  kind: "patient" | "appointment" | "navigation";
}

type SearchStorage = Pick<Storage, "getItem" | "setItem">;

export function recentSearchKey(userId: string): string {
  return `${SEARCH_RECENTS_KEY}:${userId}`;
}

export function readRecentSearches(
  userId: string,
  storage: SearchStorage = localStorage,
): StoredRecentSearch[] {
  try {
    const parsed = JSON.parse(storage.getItem(recentSearchKey(userId)) ?? "[]") as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter(
        (entry): entry is StoredRecentSearch =>
          !!entry &&
          typeof entry === "object" &&
          typeof entry.id === "string" &&
          typeof entry.label === "string" &&
          typeof entry.subtitle === "string" &&
          typeof entry.href === "string" &&
          entry.href.startsWith("/") &&
          ["patient", "appointment", "navigation"].includes(entry.kind),
      )
      .slice(0, 5);
  } catch {
    return [];
  }
}

export function writeRecentSearches(
  userId: string,
  searches: StoredRecentSearch[],
  storage: SearchStorage = localStorage,
): void {
  storage.setItem(recentSearchKey(userId), JSON.stringify(searches.slice(0, 5)));
}
